import axios from 'axios';
import { API_BASE_URL } from '../config';
import LocalStorageService from '../utils/localStorageService';
import { createErrorLogger, ErrorType } from '../utils/logger';

const logger = createErrorLogger('ReprocessingService');
const SESSION_TOKEN_KEY = 'autobot_session_token';

function getAdminHeaders() {
  const token = LocalStorageService.getItem(SESSION_TOKEN_KEY);
  if (!token) {
    throw new Error('Authentication token is required for admin reprocessing actions');
  }
  return {
    Authorization: `Bearer ${token}`
  };
}

async function postReprocess(path) {
  try {
    const response = await axios.post(`${API_BASE_URL}${path}`, null, {
      headers: getAdminHeaders()
    });
    return response.data;
  } catch (error) {
    logger.error('postReprocess', 'Reprocess request failed', {
      path,
      status: error.response?.status,
      detail: error.response?.data?.detail,
      message: error.message
    }, ErrorType.API_CALL);
    throw error;
  }
}

const reprocessingService = {
  reprocessAllCVs: async () => {
    logger.info('reprocessAllCVs', 'Starting sequential CV reprocessing');
    return postReprocess('/cv/reprocess/all');
  },

  reprocessAllJobsWithConcordance: async () => {
    logger.info('reprocessAllJobsWithConcordance', 'Starting sequential job reprocessing with CV concordance');
    return postReprocess('/job/reprocess/all');
  }
};

export default reprocessingService;
